import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import SignUp from './Components/Logins/Signup';
import SignIn from './Components/Logins/Signin';
import ForgotPassword from './Components/Logins/ForgotPassword';
import Forgotpasswordsuccess from './Components/Logins/Forgotpasswordsuccess';
import NewProject from './Components/MainPages/NewProject';
import '../src/App.css';
import Designation from './Components/Pages/Designation.js';
import Stakeholder from './Components/Pages/Stakeholder.js';
import Requests from './Components/Pages/Requests.js';
import Managerinput from './Components/Pages/Managerinput.js';
import ManagerView from './Components/Pages/Managerview.js';
import Masterscopeview from './Components/Pages/Masterscopeview.js';
import PrivateRoute from './Components/Logins/PrivateRoute.js';
import MyProjects from './Components/MainPages/Dashboard.js';
import GeneratedFiles from './Components/Pages/Generatedfiles.js';
import Layout from './Components/MainPages/Layout.js';
import ViewGeneratedDoc from './Components/Pages/ViewGeneratedDoc.js';
import AddStakeholder from './Components/Pages/AddStakeholder.js';
import ComingSoon from './Components/Pages/Comingsoon.js';
import Documents from './Components/Pages/Documents.js';
import MyProfile from './Components/MainPages/Myprofile.js';
import ChangePassword from './Components/Pages/ChangePassword.js';
import Billing from './Components/Pages/Billing.js';
import SampleInputs from './Components/Pages/SampleInputs.js';
import EmailVerification from './Components/Pages/EmailVerification.js';
import PlansPage from './Components/Pages/Plans.js';
import CardDetails from './Components/Pages/CardDetail.js';
import TransactionHistory from './Components/Pages/Transactions.js';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7a5af9',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          padding: '9px 24px',
          fontSize: '1rem',
          backgroundColor: "#5a1bc2",
          color: "#fff",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            height: "3rem",
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          position: "absolute",
          top: 60,
          margin: 0,
        },
      },
      defaultProps: {
        disableBackdropClick: true,
      },
    },
  },
});



function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/passwordsuccess" element={<Forgotpasswordsuccess />} />
          <Route path="/Dashboard" element={<PrivateRoute><Layout><MyProjects /></Layout></PrivateRoute>} />
          <Route path="/newproject" element={<PrivateRoute><Layout disableBreadcrumb><NewProject /></Layout></PrivateRoute>} />
          <Route path="/addstakeholder" element={<PrivateRoute><Layout disableBreadcrumb><AddStakeholder /></Layout></PrivateRoute>} />
          <Route path="/managerinput" element={<PrivateRoute><Layout disableBreadcrumb><Managerinput /></Layout></PrivateRoute>} />
          <Route path="/desination" element={<PrivateRoute><Layout><Designation /></Layout></PrivateRoute>} />
          <Route path="/stakeholders" element={<PrivateRoute><Layout><Stakeholder /></Layout></PrivateRoute>} />
          <Route path="/requests" element={<PrivateRoute><Layout><Requests /></Layout></PrivateRoute>} />
          <Route path="/projectview" element={<PrivateRoute><Layout disableBreadcrumb><ManagerView/></Layout></PrivateRoute>} />
          <Route path="/masterScopeview" element={<PrivateRoute><Layout disableBreadcrumb><Masterscopeview/></Layout></PrivateRoute>} />
          <Route path="/generatedfiles" element={<PrivateRoute><Layout disableBreadcrumb><GeneratedFiles/></Layout></PrivateRoute>} />
          <Route path="/generateddocs" element={<PrivateRoute><Layout disableBreadcrumb><ViewGeneratedDoc/></Layout></PrivateRoute>} />
          <Route path="/documents" element={<PrivateRoute><Layout><Documents/></Layout></PrivateRoute>} />
          <Route path="/billing" element={<PrivateRoute><Layout disableBreadcrumb><Billing/></Layout></PrivateRoute>} />
          <Route path="/myprofile" element={<PrivateRoute><Layout><MyProfile/></Layout></PrivateRoute>} />
          <Route path="/changepassword" element={<PrivateRoute><Layout><ChangePassword/></Layout></PrivateRoute>} />
          <Route path="/plans" element={<PrivateRoute><Layout><PlansPage/></Layout></PrivateRoute>} />
          <Route path="/Carddetails" element={<PrivateRoute > <Layout disableBreadcrumb><CardDetails/></Layout></PrivateRoute>} />
          <Route path="/transactionhistory" element={<PrivateRoute><Layout disableBreadcrumb><TransactionHistory/></Layout></PrivateRoute>} />
          <Route path="/sampleinputs" element={<SampleInputs/>} />
          <Route path="/emailverification" element={<EmailVerification/>} />
          <Route path="*" element={ <Layout><ComingSoon /></Layout>} />

        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
